import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';

import ModalSection from '../ModalSection';
import ToolModel from '../../../../models/ToolModel';
import { SIDEBAR_ACTIONS } from '../../../../../constants/actionsConstants';
import RightModalLayout from '../../../../layouts/Modal/RightModalLayout';
import InputComponent from '../../../../components/InputMC';
import FormProviderMC from '../../../../components/FormProviderMC';

const HandoffModal = ({ agentId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('ChatbotIA');

  const [handoffMessage, setHandoffMessage] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (agentId) {
      loadHandoffMessage();
    }
  }, [agentId]);

  const toggleHandoffModal = () => {
    dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
  };

  const loadHandoffMessage = () => {
    if (!agentId) {
      showtoast(t('config.error_loading'));
      return;
    }

    ToolModel.get(agentId, { type: 'transfer_to_human_agent' })
      .then((response) => {
        const tools = response.data || [];
        if (tools.length > 0) {
          const tool = tools[0];
          setHandoffMessage(tool.config?.message || '');
        }
        setSaving(false);
      })
      .catch((err) => {
        setSaving(false);
        showtoast(err.message || t('config.error_loading'));
      });
  };

  const methods = useForm();

  const updateInfo = (value) => {
    setHandoffMessage(value);
  };

  const onSubmit = () => {
    if (!agentId) {
      showtoast(t('config.error_loading'));
      return;
    }

    setSaving(true);

    const toolData = {
      config: {
        message: handoffMessage
      }
    };

    ToolModel.updateByType(agentId, 'transfer_to_human_agent', toolData)
      .then(() => {
        setTimeout(() => {
          showtoast(t('config.save_success'));
          setSaving(false);
          toggleHandoffModal();
        }, 1000);
      })
      .catch((error) => {
        setSaving(false);
        showtoast(error.message || t('config.save_error'));
        toggleHandoffModal();
      });
  };

  return (
    <div className="tw-wrapper">
      <RightModalLayout
        title={t('config.handoff.modal_title')}
        submitAction={onSubmit}
        submitLabel={t('guides.sidebar_create.update')}
        submitDisabled={saving}
      >
        <FormProviderMC methods={methods}>
          <ModalSection
            title={t('config.handoff.section_1_title')}
            description={t('config.handoff.section_1_description')}
            afterContent={(
              <InputComponent
                name="handoff_message"
                value={handoffMessage || ''}
                label={t('config.handoff.message')}
                placeholder={t('config.handoff.example') || ''}
                onChange={(_, value) => { updateInfo(value); }}
                className="tw-min-h-[120px] tw-resize-none !tw-placeholder-gray-500 tw-h-auto tw-mt-4"
                textarea
                useFloatingLabel
              />
            )}
          />
        </FormProviderMC>
      </RightModalLayout>
    </div>
  );
};

export default HandoffModal;
